import { useEffect } from 'react';

const useScrollToTop = (page = null, otherElement = null) => {
    // useEffect(() => {
    //     window.scroll({
    //         top: 0,
    //         behavior: 'smooth',
    //     });
    // }, [page, el1, el2, el3]);
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [page, otherElement]);
};

export default useScrollToTop;
